import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateCart } from "@redux/booking/slice";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import theme from "../../theme";

const CartTimer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setting } = useSelector((store) => store.settingsReducer);
  const { cartTime } = useSelector((store) => store.bookingReducer);
  const cartTimer = setting?.data?.checkoutTimer;
  const [countDownTime, setCountDownTime] = useState(cartTime);
  const minutes = Math.floor(countDownTime / 60);
  const seconds = countDownTime % 60;

  const removeCartItems = () => {
    dispatch(updateCart({ removeItem: true }));
    if (window.location.pathname === "/checkout") {
      navigate(-1);
    }
  };

  useEffect(() => {
    countDownTime <= 0 && removeCartItems();
  }, [countDownTime]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDownTime((prevTime) => prevTime - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [countDownTime]);

  useEffect(() => {
    const storedStartTime = cartTime;
    if (storedStartTime) {
      const elapsedTime = Math.floor(
        (Date.now() - parseInt(storedStartTime, 10)) / 1000
      );
      const remainingTime = Math.max(cartTimer * 60 - elapsedTime, 0);
      setCountDownTime(remainingTime);
      if (remainingTime == 0) {
        localStorage.removeItem("GolfCartStartTime");
        removeCartItems();
      }
    } else {
      localStorage.setItem("GolfCartStartTime", Date.now().toString());
    }
  }, [cartTime, countDownTime]);

  return (
    <div className="flex flex-row justify-start items-center gap-x-1">
      <AccessTimeIcon
        fontSize="small"
        sx={{ color: theme.colors.buttonTextColor }}
      />
      <p
        style={{
          fontWeight: "bold",
          fontSize: "17px",
          color: "white",
        }}
      >
        {`${minutes} : ${seconds < 10 ? "0" : ""}${seconds}`}
      </p>
    </div>
  );
};

export default CartTimer;
